<template lang="pug">
  vm-prompt(@vm-cancel="close" vm-size="medium" @vm-accept="saveRecord" @vm-close="close" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="textLength" :vm-active="isModalVisible" :vm-title='getTitle')
    vm-row.modal-container(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-lg=12 v-if="this.$route.path != '/pages/people-detail/2'")
        b-form-group
          vm-select(:placeholder='$t("questions.category_name")' v-model="newRecord.category_name" :label='$t("questions.category_name")')
            vm-select-item(:key="index" :value="item.name" :text="item.name" v-for="(item,index) in categories")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-tabs
            vm-tab(vm-label='Español')
              vm-col.mt-1(vm-justify="center", vm-align="center", vm-w=12)
                b-form-group
                  vm-input(autofocus :placeholder='$t("questions.question")' :danger-text="$t('validation.required', { attribute: $t('questionss.question') })" v-model="newRecord.traductions[0].question" :label='$t("questions.question")')
              vm-col(vm-justify="center", vm-align="center", vm-w=12)
                b-form-group
                  vm-text-editor(v-model="newRecord.traductions[0].answer" maxLength="750" :danger-text="$t('validation.required', { attribute: $t('questions.answer') })" :label="$t('questions.answer')" :placeholder="$t('questions.answer')")
            vm-tab(vm-label='Ingles')
              vm-col.mt-1(vm-justify="center", vm-align="center", vm-w=12)
                b-form-group
                  vm-input(autofocus :placeholder='$t("questions.question")' v-model="newRecord.traductions[1].question" :label='$t("questions.question")')
              vm-col(vm-justify="center", vm-align="center", vm-w=12)
                b-form-group
                  vm-text-editor(v-model="newRecord.traductions[1].answer" :label="$t('questions.answer')" :placeholder="$t('questions.answer')")
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Questions')

export default {
  name: 'ModalQuestions',
  mixins: [ModalMixin1],
  props: {
    newRecord: {
      type: Object,
      default: () => {}
    },
    isAdd: {
      default: true,
      type: Boolean
    }
  },
  // data: () => ({}),
  validations () {
    return {
      form: {
        name: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isModalVisible', 'categories']),
    textLength () {
      return this.newRecord.traductions[0].question.length > 0 && this.newRecord.traductions[0].answer.length > 0
    }
  },
  watch: {
    isModalVisible (flag) {
      this.loadCategories()
    },
    getTitle () {
      return this.isAdd ? this.$t('questions.add') : this.$t('questions.edit')
    }
  },
  async created () {
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'addRecord',
      'editRecord',
      'deleteRecord',
      'setModalVisible',
      'loadCatalog',
      'loadCategories',
      'addQuestion',
      'updateQuestion'
    ]),
    async saveRecord () {
      if (this.newRecord.traductions[1].question.length === 0) this.newRecord.traductions[1].question = this.newRecord.traductions[0].question
      if (this.newRecord.traductions[1].answer.length === 0) this.newRecord.traductions[1].answer = this.newRecord.traductions[0].answer
      if (this.isAdd) {
        await this.addQuestion({ data: this.newRecord })
      } else {
        await this.updateQuestion({ data: this.newRecord })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-container {
  max-height: 450px;
  overflow-y: scroll;
}
</style>
